export default __webpack_public_path__ + "static/media/user_info_updated.87062b7f.svg";